'use strict';

/**
 * Permission Service (wdPermissionService.js).
 * Permission Service.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @copyright 2018 Webduct Systems Inc.
 *
 * @version
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
angular.module('wd.service.permission', ['wd.helper.permissions'])
    .factory('wdPermissionService',
    ['$q', 'wdPermissionHelper',
        function($q, wdPermissionHelper) {

            /**
             * Service: Permissions
             *
             * @since 1.0.0
             * @type {Object}
             */
            var service = {};

            /**
             * Initialize Permissions
             *
             * @since 1.0.0
             * @returns {Q.Promise}
             */
            service.initialize = function () {

                var deferred = $q.defer();

                // If we ever want to pull permissions
                // from an API call, we do that here
                wdPermissionHelper.setPermissions();
                deferred.resolve(true);

                return deferred.promise;

            };

            return service;

        }]);

// EOF